<template>
    <div class="relative overflow-hidden bg-secondary-bg border-y-4 border-accent" id="community-grid">
        <div class="my-16 tablet-lg:my-36">
            <div
                class="
          grid
          items-stretch
          gap-8
          mx-auto
          max-w-76 mobile-lg:max-w-xs mobile-xl:max-w-lg tablet-sm:max-w-2xl tablet-lg:max-w-4xl laptop-lg:max-w-6xl desktop:max-w-7xl
          grid-cols-1 tablet-sm:grid-cols-2 laptop-sm:grid-cols-4
        "
            >
                <!-- HEADER -->
                <div
                    class="
            col-span-1 tablet-sm:col-span-2 desktop:col-span-2
            h-full flex
          "
                >
                    <div
                        class="border-t-4 border-b-4 border-accent py-4 px-2 w-full flex flex-col items-center justify-center">
                        <div>
                            <p class="text-base font-semibold leading-7 text-indigo-600">Decided on an area?</p>
                            <h2
                                class="text-4xl laptop-lg:text-5xl desktop:text-5xl ultra-wide:text-6xl mt-2 font-bold tracking-tight text-black"
                            >
                                Find Your Neighborhood
                            </h2>
                        </div>
                    </div>
                </div>

                <!-- IMAGE GRID ITEMS -->
                <li
                    v-for="file in images"
                    :key="file.source"
                    class="relative border-accent border-2 rounded-sm overflow-hidden shadow-xl-left shadow-xl-bottom shadow-xl-right list-none"
                >
                    <Link :href="file.href" class="w-full relative">
                        <div
                            class="group block w-full overflow-hidden rounded-sm bg-accent focus-within:ring-2 focus-within:ring-accent focus-within:ring-offset-2 focus-within:ring-offset-secondary-accent relative"
                        >
                            <img
                                :src="file.defaultSrc"
                                :srcset="file.srcset"
                                sizes="(min-width: 1920px) 252px, (min-width: 1280px) 310px, (min-width: 1024px) 262px, (min-width: 768px) 233px, (min-width: 375px) 307px, 252px"
                                :alt="file.title"
                                class="pointer-events-none object-contain object-center opacity-100 group-hover:opacity-75 min-w-full h-auto"
                                loading="lazy"
                            />
                            <div class="absolute inset-0 flex flex-col items-center justify-end">
                                <div class="relative w-full py-3">
                                    <div class="relative z-10 px-4 py-1 bg-accent">
                                        <p
                                            class="text-primary-text text-lg desktop:text-xl font-subtitle font-semibold text-center">
                                            {{ file.title }}
                                        </p>
                                        <p class="text-primary-text text-sm font-medium text-center">
                                            {{ file.size }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <button type="button" class="absolute inset-0 focus:outline-none">
                                <span class="sr-only">View details for {{ file.title }}</span>
                            </button>
                        </div>
                    </Link>
                </li>
            </div>
        </div>
    </div>
</template>


<script setup>
import { Link } from "@inertiajs/vue3";

// TODO: Integrate the optimized images for mobile
const images = [
    {
        title: "Jacksonville Beach Real Estate",
        source: "/images/theme/community_grid/beaches-",
        href: "/neighborhoods#beaches",
        anchor: "beaches",
        id: "beaches-pic",
        srcset: "/images/theme/community_grid/beaches-310x232.webp 310w, /images/theme/community_grid/beaches-307x230.webp 307w, /images/theme/community_grid/beaches-262x196.webp 262w, /images/theme/community_grid/beaches-252x188.webp 252w, /images/theme/community_grid/beaches-233x174.webp 233w",
        sizes: "(min-width: 1920px) 252px, (min-width: 1280px) 310px, (min-width: 1024px) 262px, (min-width: 768px) 236px, (min-width: 375px) 307px, 252px",
        defaultSrc: "/images/theme/community_grid/beaches-310x232.webp"
    },
    {
        title: "Southeast Jacksonville Homes",
        source: "/images/theme/community_grid/south-side-jax-",
        href: "/neighborhoods#jacksonville",
        anchor: "jacksonville",
        id: "southside-pic",
        srcset: "/images/theme/community_grid/south-side-jax-310x232.webp 310w, /images/theme/community_grid/south-side-jax-307x230.webp 307w, /images/theme/community_grid/south-side-jax-262x196.webp 262w, /images/theme/community_grid/south-side-jax-252x188.webp 252w, /images/theme/community_grid/south-side-jax-233x174.webp 233w",
        sizes: "(min-width: 1920px) 252px, (min-width: 1280px) 310px, (min-width: 1024px) 262px, (min-width: 768px) 236px, (min-width: 375px) 307px, 252px",
        defaultSrc: "/images/theme/community_grid/south-side-jax-310x232.webp"
    },
    {
        title: "Mandarin Real Estate",
        source: "/images/theme/community_grid/mandarin-",
        href: "/neighborhoods#mandarin",
        anchor: "mandarin",
        id: "mandarin-pic",
        srcset: "/images/theme/community_grid/mandarin-310x232.webp 310w, /images/theme/community_grid/mandarin-307x230.webp 307w, /images/theme/community_grid/mandarin-262x196.webp 262w, /images/theme/community_grid/mandarin-252x188.webp 252w, /images/theme/community_grid/mandarin-233x174.webp 233w",
        sizes: "(min-width: 1920px) 252px, (min-width: 1280px) 310px, (min-width: 1024px) 262px, (min-width: 768px) 236px, (min-width: 375px) 307px, 252px",
        defaultSrc: "/images/theme/community_grid/mandarin-310x232.webp"
    },
    {
        title: "Homes in Julington Creek",
        source: "/images/theme/community_grid/jcp-",
        href: "/neighborhoods#nwstjohns",
        anchor: "nwstjohns",
        id: "nw-st-johns-pic",
        srcset: "/images/theme/community_grid/jcp-310x232.webp 310w, /images/theme/community_grid/jcp-307x230.webp 307w, /images/theme/community_grid/jcp-262x196.webp 262w, /images/theme/community_grid/jcp-252x188.webp 252w, /images/theme/community_grid/jcp-233x174.webp 233w",
        sizes: "(min-width: 1920px) 252px, (min-width: 1280px) 310px, (min-width: 1024px) 262px, (min-width: 768px) 236px, (min-width: 375px) 307px, 252px",
        defaultSrc: "/images/theme/community_grid/jcp-310x232.webp"
    },
    {
        title: "Ponte Vedra Homes",
        source: "/images/theme/community_grid/pontevedra-",
        href: "/neighborhoods#pontevedra",
        anchor: "pontevedra",
        id: "ponte-vedra-pic",
        srcset: "/images/theme/community_grid/pontevedra-310x232.webp 310w, /images/theme/community_grid/pontevedra-307x230.webp 307w, /images/theme/community_grid/pontevedra-262x196.webp 262w, /images/theme/community_grid/pontevedra-252x188.webp 252w, /images/theme/community_grid/pontevedra-233x174.webp 233w",
        sizes: "(min-width: 1920px) 252px, (min-width: 1280px) 310px, (min-width: 1024px) 262px, (min-width: 768px) 236px, (min-width: 375px) 307px, 252px",
        defaultSrc: "/images/theme/community_grid/pontevedra-310x232.webp"
    },
    {
        title: "County Road 210 Corridor",
        source: "/images/theme/community_grid/rivertown-",
        href: "/neighborhoods#rivertown",
        anchor: "rivertown",
        id: "rivertown-pic",
        srcset: "/images/theme/community_grid/rivertown-310x232.webp 310w, /images/theme/community_grid/rivertown-307x230.webp 307w, /images/theme/community_grid/rivertown-262x196.webp 262w, /images/theme/community_grid/rivertown-252x188.webp 252w, /images/theme/community_grid/rivertown-233x174.webp 233w",
        sizes: "(min-width: 1920px) 252px, (min-width: 1280px) 310px, (min-width: 1024px) 262px, (min-width: 768px) 236px, (min-width: 375px) 307px, 252px",
        defaultSrc: "/images/theme/community_grid/rivertown-310x232.webp"
    }
];

</script>
